// extracted by mini-css-extract-plugin
export default {"newTaskContent":"NewAgentTaskForm-module__newTaskContent--KrMQX"};